import angular from 'angular';
import copy from 'app/constants';
import { alerts } from 'app/components/global';
import { orgDataService, loaderService } from 'app/services';


import editCustomerSettingsDirective from './edit-customer-settings.directive';
import EditCustomerSettingsDirectiveController from './edit-customer-settings.directive.controller';

export default angular.module('app.components.admin.customerAdministration.editCustomerSettings', [
  copy,
  alerts,

  orgDataService,
  loaderService
])
  .directive('caEditCustomerSettings', editCustomerSettingsDirective)
  .controller('CAEditCustomerSettingsDirectiveController', EditCustomerSettingsDirectiveController)
  .name;

console.log('app.admin.customerAdministration.editCustomerSettings created');
